/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const PaymentType = {
    CASH: 'CASH',
    POS: 'POS',
    FORTE: 'FORTE',
    RAHMET: 'RAHMET',
    SENIM: 'SENIM',
    CHECKING_ACCOUNT: 'CHECKING_ACCOUNT',
    KASPI: 'KASPI',
    HALYK: 'HALYK',
    DEBT: 'DEBT',
    KASPI_POS: 'KASPI_POS',
    PAYBOX: 'PAYBOX',
    UZ_PAYBOX: 'UZ_PAYBOX',
    COIN: 'COIN',
    SQUAREUP: 'SQUAREUP',
    TIP: 'TIP',
    TAX: 'TAX'
} as const;
export type PaymentType = typeof PaymentType[keyof typeof PaymentType];

